import { TimeseriesGenericCanvasLayout } from './TimeseriesGenericCanvasLayout.js';
import { applyOpacityToCanvas } from '../../core/utils/apply-opacity-to-canvas.js';
import { safeGet } from '../../core/utils/safe-get.js';
import { useHighlightedSeriesIdState } from '../hooks/store/selectors.js';
import { useTimeseriesFilteredData } from '../hooks/useTimeseriesFilteredData.js';
import type { TimeseriesSlotProps } from '../types/timeseries.js';

interface TimeseriesHighlightedCanvasLayoutProps {
  handleOpacity: (val: string) => void;
}

export const TimeseriesHighlightedCanvasLayout = ({
  handleOpacity,
}: TimeseriesHighlightedCanvasLayoutProps) => {
  const highlightedSeriesId = useHighlightedSeriesIdState();
  const { dataPerVariant, seriesMap } = useTimeseriesFilteredData();
  handleOpacity(applyOpacityToCanvas(highlightedSeriesId));

  if (!highlightedSeriesId) {
    return null;
  }

  const filterByHighlightedId = <T extends TimeseriesSlotProps>(
    series: T[],
  ): T[] =>
    series.filter((s) => safeGet(seriesMap, s).id === highlightedSeriesId);

  const filteredDataPerVariant = {
    line: filterByHighlightedId(dataPerVariant.line),
    area: filterByHighlightedId(dataPerVariant.area),
    bar: filterByHighlightedId(dataPerVariant.bar),
    band: filterByHighlightedId(dataPerVariant.band),
    shapePriority: dataPerVariant.shapePriority,
  };

  return (
    <TimeseriesGenericCanvasLayout dataPerVariant={filteredDataPerVariant} />
  );
};
